<template>
  <header class="notes_action_header">
    <!-- LEFT ACTIONS -->
    <div class="header_left">
      <!-- Back / Plus button -->
      <button
        v-if="isEditableView || activeView === 'read-only'"
        type="button"
        class="header_tool_btn"
        :title="activeView === 'my-edit' ? 'New Note' : 'Back to Notes'"
        :disabled="disabled"
        @click="$emit('back')"
      >
        <!-- Plus icon when editing own note -->
        <svg v-if="activeView === 'my-edit'" class="tool_svg" viewBox="0 0 20 20" fill="currentColor">
          <path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z" />
        </svg>
        <!-- Arrow back icon for other views -->
        <svg v-else class="tool_svg" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M17 10a.75.75 0 01-.75.75H5.612l4.158 3.96a.75.75 0 11-1.04 1.08l-5.5-5.25a.75.75 0 010-1.08l5.5-5.25a.75.75 0 111.04 1.08L5.612 9.25H16.25A.75.75 0 0117 10z" clip-rule="evenodd" />
        </svg>
      </button>

      <!-- Primary Plus Button in List View -->
      <!-- <button
        v-else-if="activeView === 'list'"
        type="button"
        class="header_tool_btn primary_accent"
        title="Create Note"
        :disabled="disabled"
        @click="$emit('new-note')"
      >
        <svg class="tool_svg" viewBox="0 0 20 20" fill="currentColor">
          <path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z" />
        </svg>
      </button> -->
    </div>

    <!-- RIGHT ACTIONS -->
    <div class="header_right">
      <!-- Shared vs Personal Toggle Pill -->
      <button
        v-if="showSharedToggle"
        type="button"
        class="shared_scope_pill"
        :class="{ active: isSharedActive }"
        :disabled="isLoadingShared"
        @click="$emit('toggle-shared')"
      >
        <svg class="pill_svg" viewBox="0 0 20 20" fill="currentColor">
          <path d="M7 8a3 3 0 100-6 3 3 0 000 6zM14.5 9a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM1.615 16.428a1.224 1.224 0 01-.569-1.175 6.002 6.002 0 0111.908 0c.058.467-.172.92-.57 1.174A9.953 9.953 0 017 18a9.953 9.953 0 01-5.385-1.572zM14.5 16h-.106c.07-.297.088-.611.048-.933a7.47 7.47 0 00-1.588-3.755 4.502 4.502 0 015.874 2.636.818.818 0 01-.36.98A7.465 7.465 0 0114.5 16z" />
        </svg>
        <span>{{ isSharedActive ? 'Personal Notes' : 'Shared Notes' }}</span>
      </button>

      <!-- Create Mode: Pencil Toggle -->
      <button
        v-if="activeView === 'list' && !notesBoardInsert"
        type="button"
        class="header_tool_btn"
        title="Draft Note"
        @click="$emit('new-note')"
      >
        <svg fill="currentColor" viewBox="0 0 24 24" width="20" height="20" class="tool_svg">
          <path d="M21.13 2.86a3 3 0 0 0-4.17 0l-13 13L2 22l6.19-2L21.13 7a3 3 0 0 0 0-4.16zM6.77 18.57l-1.35-1.34L16.64 6 18 7.35z"></path>
        </svg>
        <!-- <svg class="tool_svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125" />
        </svg> -->
      </button>

      <!-- Editor Actions Cluster -->
      <template v-if="isEditableView">
        <button
          type="button"
          class="header_tool_btn"
          title="Expand Preview"
          @click="$emit('expand')"
        >
          <svg class="tool_svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15" />
          </svg>
        </button>

        <button
          type="button"
          class="header_tool_btn"
          :class="{ active: isConvertingPdf }"
          title="Export to PDF"
          @click="$emit('export-pdf')"
        >
          <i class="fa fa-file-pdf-o"></i>
        </button>

        <button
          v-if="activeView === 'my-edit'"
          type="button"
          class="header_tool_btn btn_danger"
          title="Delete Note"
          :disabled="disabled"
          @click="$emit('delete')"
        >
          <svg class="tool_svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
          </svg>
        </button>

        <button
          v-if="activeView === 'shared-edit'"
          type="button"
          class="header_tool_btn"
          title="Back to My Notes"
          :disabled="disabled"
          @click="$emit('back-my-notes')"
        >
          <svg class="tool_svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M2.25 12.75V12A2.25 2.25 0 014.5 9.75h15A2.25 2.25 0 0121.75 12v.75m-8.69-6.44l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z" />
          </svg>
        </button>

        <!-- Primary Done Checkmark -->
        <button
          type="button"
          class="header_tool_btn btn_confirm"
          title="Done / Save changes"
          :disabled="disabled"
          @click="$emit('done')"
        >
          <svg class="tool_svg" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd" />
          </svg>
        </button>
      </template>

      <!-- Save Button for Draft Note -->
      <button
        v-if="activeView === 'create' && notesBoardInsert"
        type="button"
        class="header_tool_btn btn_confirm"
        title="Save Note"
        :disabled="disabled"
        @click="$emit('save-new')"
      >
        <svg class="tool_svg" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd" />
        </svg>
      </button>

      <!-- Read-Only Badge -->
      <span v-if="activeView === 'read-only'" class="read_only_badge">
        <svg class="badge_svg" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M10 1a4.5 4.5 0 00-4.5 4.5V9H5a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2v-6a2 2 0 00-2-2h-.5V5.5A4.5 4.5 0 0010 1zm3 8V5.5a3 3 0 10-6 0V9h6z" clip-rule="evenodd" />
        </svg>
        Read Only
      </span>
    </div>
  </header>
</template>

<script>
export default {
  name: 'NotesHeaderActions',
  props: {
    activeView: { type: String, required: true },
    isEditableView: { type: Boolean, default: false },
    notesBoardInsert: { type: Boolean, default: false },
    isSharedActive: { type: Boolean, default: false },
    isLoadingShared: { type: Boolean, default: false },
    isConvertingPdf: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    showSharedToggle() {
      return (
        this.activeView === 'list' ||
        (this.activeView === 'create' && !this.notesBoardInsert)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
// Glassmorphic tokens
$glass-bg: rgba(255, 255, 255, 0.04);
$glass-border: rgba(255, 255, 255, 0.01);
$glass-border-top: rgba(255, 255, 255, 0.16);
$glass-hover: rgba(255, 255, 255, 0.09);

$text-bright: #ffffff;
$text-secondary: #94a3b8;
$text-muted: #565d6d;

$brand-primary: #6366f1;
$brand-emerald: #10b981;
$brand-rose: #f43f5e;

.notes_action_header {
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 15px;
  background: rgba(12, 13, 18, 0.7);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.02);
  min-height: 45px;
  overflow: hidden;

  .header_left,
  .header_right {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}

/* SQUIRCLE GLASS TOOL BUTTON */
.header_tool_btn {
  background: $glass-bg;
  border: 1px solid $glass-border;
  width: 26px;
  height: 26px;
  border-radius: 5px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: $text-secondary;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);

  .tool_svg {
    width: 20px;
    height: 20px;
    transition: transform 0.15s ease;
  }

  .fa{font-size: 18px;}

  &:hover:not(:disabled) {
    background: $glass-hover;
    border-color: rgba(255, 255, 255, 0.18);
    color: $text-bright;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);

    .tool_svg {
      transform: scale(1.05);
    }
  }

  &:active:not(:disabled) {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
    box-shadow: none;
  }

  /* Primary Plus Trigger */
  &.primary_accent {
    background: rgba(99, 102, 241, 0.12);
    border-color: rgba(99, 102, 241, 0.25);
    color: #818cf8;

    &:hover:not(:disabled) {
      background: rgba(99, 102, 241, 0.22);
      border-color: rgba(99, 102, 241, 0.45);
      color: #ffffff;
      box-shadow: 0 0 12px rgba(99, 102, 241, 0.35);
    }
  }

  /* Success / Done Action */
  &.btn_confirm {
    background: rgba(16, 185, 129, 0.12);
    border-color: rgba(16, 185, 129, 0.25);
    color: $brand-emerald;

    &:hover:not(:disabled) {
      background: rgba(16, 185, 129, 0.22);
      border-color: rgba(16, 185, 129, 0.45);
      color: #ffffff;
      box-shadow: 0 0 12px rgba(16, 185, 129, 0.35);
    }
  }

  /* Danger / Trash Action */
  &.btn_danger:hover:not(:disabled) {
    background: rgba(244, 63, 94, 0.12);
    border-color: rgba(244, 63, 94, 0.25);
    color: $brand-rose;
    box-shadow: 0 0 12px rgba(244, 63, 94, 0.25);
  }

  /* Active / Loading State */
  &.active {
    background: rgba(99, 102, 241, 0.2);
    border-color: $brand-primary;
    color: #ffffff;
  }
}

/* SLEEK SHARED TOGGLE PILL */
.shared_scope_pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 26px;
  padding: 0 10px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 5px;
  border: 1px solid $glass-border;
  background: $glass-bg;
  color: $text-secondary;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  // box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);

  .pill_svg {
    width: 14px;
    height: 14px;
  }

  &:hover:not(:disabled) {
    background: $glass-hover;
    border-color: rgba(255, 255, 255, 0.16);
    color: $text-bright;
    transform: translateY(-1px);
  }

  &.active {
    background: rgba(99, 102, 241, 0.14);
    border-color: rgba(99, 102, 241, 0.3);
    color: #a5b4fc;
    // box-shadow: 0 0 14px rgba(99, 102, 241, 0.25);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

/* READ-ONLY BADGE */
.read_only_badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 28px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: $brand-rose;
  padding: 0 10px;
  background: rgba(244, 63, 94, 0.1);
  border: 1px solid rgba(244, 63, 94, 0.25);
  border-radius: 6px;
  backdrop-filter: blur(8px);

  .badge_svg {
    width: 12px;
    height: 12px;
  }
}
</style>